export default __webpack_public_path__ + "static/media/106.bfc0e211.jpg";